import {connect} from 'react-redux';
import {Microcentrifuge as Component} from './Microcentrifuge';
import {
  createMicrocentrifuge,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("microcentrifuge") &&
     state.notebook.protocolSection.scene.apparatus.microcentrifuge.some(
       microcentrifuge => microcentrifuge.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].type,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createMicrocentrifuge: (data)=>{
      dispatch(createMicrocentrifuge(data))
    },
  };
}

export const Microcentrifuge = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
